import { render, staticRenderFns } from "./PermissaoIndex.vue?vue&type=template&id=2d8463ba&"
import script from "./PermissaoIndex.vue?vue&type=script&lang=js&"
export * from "./PermissaoIndex.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports